import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  filter: "createdOn",
  filterType: "date",
  sort: "createdOn"
}
const _hoisted_2 = {
  filter: "user.name",
  sort: "user.name"
}
const _hoisted_3 = {
  filter: "nazione",
  sort: "nazione"
}
const _hoisted_4 = {
  filter: "dataRicevuta",
  filterType: "date",
  sort: "dataRicevuta"
}
const _hoisted_5 = {
  filter: "importo",
  sort: "importo"
}
const _hoisted_6 = {
  filter: "gestitaOn",
  filterType: "date",
  sort: "gestitaOn"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { colspan: "99" }
const _hoisted_10 = ["href"]
const _hoisted_11 = ["href"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_op_table = _resolveComponent("op-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_op_table, {
      class: "table table-striped",
      items: _ctx.richieste
    }, {
      default: _withCtx((opData) => [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_1, [
              _createVNode(_component_localized_text, {
                localizedKey: "Data creazione",
                text: "Data creazione"
              })
            ]),
            _createElementVNode("td", _hoisted_2, [
              _createVNode(_component_localized_text, {
                localizedKey: "Utente",
                text: "Utente"
              })
            ]),
            _createElementVNode("td", _hoisted_3, [
              _createVNode(_component_localized_text, {
                localizedKey: "Nazione",
                text: "Nazione"
              })
            ]),
            _createElementVNode("td", _hoisted_4, [
              _createVNode(_component_localized_text, {
                localizedKey: "Data ricevuta",
                text: "Data ricevuta"
              })
            ]),
            _createElementVNode("td", _hoisted_5, [
              _createVNode(_component_localized_text, {
                localizedKey: "Importo",
                text: "Importo"
              })
            ]),
            _createElementVNode("td", null, [
              _createVNode(_component_localized_text, {
                localizedKey: "Allegato",
                text: "Allegato"
              })
            ]),
            _createElementVNode("td", _hoisted_6, [
              _createVNode(_component_localized_text, {
                localizedKey: "Data gestione",
                text: "Data gestione"
              })
            ]),
            _hoisted_7
          ])
        ]),
        _createElementVNode("tbody", null, [
          (opData.items.length == 0)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [
                _createElementVNode("td", _hoisted_9, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Nessun elemento trovato",
                    text: "Nessun elemento trovato"
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((opData.items as OM.RichiestaPagamentoUser[]), (item, i) => {
            return (_openBlock(), _createElementBlock("tr", { key: i }, [
              _createElementVNode("td", null, _toDisplayString(_ctx.$filters.date(item.createdOn)), 1),
              _createElementVNode("td", null, _toDisplayString(item.user.name), 1),
              _createElementVNode("td", null, _toDisplayString(item.nazione), 1),
              _createElementVNode("td", null, _toDisplayString(_ctx.$filters.date(item.dataRicevuta)), 1),
              _createElementVNode("td", null, _toDisplayString(item.importo), 1),
              _createElementVNode("td", null, [
                (item.allegato)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: item.allegato.publicUrl,
                      target: "_blank"
                    }, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Vedi allegato",
                        text: "Vedi allegato"
                      })
                    ], 8, _hoisted_10))
                  : _createCommentVNode("", true),
                (item.fatturaUrl)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      href: item.fatturaUrl,
                      target: "_blank"
                    }, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Vedi allegato",
                        text: "Vedi allegato"
                      })
                    ], 8, _hoisted_11))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("td", null, _toDisplayString(_ctx.$filters.date(item.gestitaOn)), 1),
              _createElementVNode("td", null, [
                (item.useRitenutaAcconto)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn btn-primary",
                      onClick: ($event: any) => (_ctx.generaRitenuta(item))
                    }, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Scarica ritenuta acconto",
                        text: "Scarica ritenuta acconto"
                      })
                    ], 8, _hoisted_12))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary ml-2",
                  onClick: ($event: any) => (_ctx.richiestaPagamentoModal(item))
                }, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Gestisci",
                    text: "Gestisci"
                  })
                ], 8, _hoisted_13)
              ])
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["items"])
  ]))
}